import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $ChildQuery = (_1, _2, _3) => ({tag: "ChildQuery", _1, _2, _3});
const ChildQuery = value0 => value1 => value2 => $ChildQuery(value0, value1, value2);
const unChildQueryBox = Unsafe$dCoerce.unsafeCoerce;
const mkChildQueryBox = Unsafe$dCoerce.unsafeCoerce;
const functorChildQuery = {map: f => v => $ChildQuery(dictApplicative => v._1(dictApplicative), v._2, x => f(v._3(x)))};
export {$ChildQuery, ChildQuery, functorChildQuery, mkChildQueryBox, unChildQueryBox};
